<template>
  <v-select
   data-cy="select-status"
    :items="items"
    :label="label"
    :value="value"
    outlined
    id="statSelect"
    :disabled="disabled"
    @change="emitValue"
  ></v-select>
</template>

<script>
import API from '@/services/api.js'
import filter from 'lodash/filter'
import {mapActions, mapGetters} from 'vuex'

// @group Application
export default {
  name: 'ApplicationStateSelect',

  props: {
    // The v-model value
    value: {
      type: Number
    },
    // The field label
    label: {
      type: String,
      // 'Status'
      default: 'Status'
    },
    // Is field disabled?
    disabled: {
      type: Boolean,
      // false
      default: false
    },
    // Is the application initiated by company?
    companyApplicant: {
      type: Boolean,
      // false
      default: false
    }
  },

  data: () => ({
    allItems: [],
    items: []
  }),

  computed: {
    ...mapGetters('basic', ['basicApplicationStates'])
  },

  watch: {
    companyApplicant() {
      const me = this
      this.items = filter(this.allItems, function (o) {
        return o.initiatedByCompany === me.companyApplicant || o.initiatedByCompany === null
      }).map(o => {
        return {value: o.id, text: o.name}
      })
    }
  },

  created() {
    this.allItems = this.basicApplicationStates
    const me = this
    this.items = filter(this.allItems, function (o) {
      return o.initiatedByCompany === me.companyApplicant || o.initiatedByCompany === null
    }).map(o => {
      return {value: o.id, text: o.name}
    })
  },

  methods: {
    emitValue(value) {
      // Fire when selection is changed
      // @arg The argument is the value of the selected option
      this.$emit('input', value)
    }
  }
}
</script>

<style>
</style>